export default "<td>{{comment.user}}</td>\n<td>{{comment.created | date: 'yyyy-MM-yy HH:mm'}}</td>\n<td>{{comment.comment}}</td>";